import { mediaQuery } from 'constants/ui';

export const getContainerStyles = ({ columnGap = 24 } = {}) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  columnGap: `${columnGap}px`,
  width: '100%',

  [mediaQuery.mobile]: {
    flexWrap: 'wrap',
    rowGap: '8px',
  },
});

export const columnStyles = ({ rowCount, hasEqualColumns }) => ({
  display: 'grid',
  gridTemplateRows: `repeat(${rowCount}, auto)`,
  gridAutoFlow: 'row',
  rowGap: '2px',
  minWidth: 0,
  flex: hasEqualColumns ? '1 1 0' : '0 0 auto',
  // A wrapping cell makes its column taller than the rest; without this the auto rows stretch to
  // fill and each column's value lands at a different height.
  ...(hasEqualColumns && {
    alignContent: 'start',
    // flex-basis 0 never overflows the line, so the container's mobile flexWrap can only engage if
    // the column keeps an intrinsic basis at that width.
    [mediaQuery.mobile]: { flex: '1 1 160px' },
  }),
});

export const cellStyles = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  columnGap: '12px',
  minWidth: 0,
};

export const dividerStyles = {
  alignSelf: 'stretch',
  borderColor: ({ palette }) => palette.divider,
};
